import feathers from "@feathersjs/feathers";
import socketio from "@feathersjs/socketio-client";
import auth from "@feathersjs/authentication-client";
import io from "socket.io-client";
import feathersVuex from "feathers-vuex";

let apiHost = "VUE_APP_API_HOST" || "http://localhost:3031";
let apiV2Host = "VUE_APP_API_HOST_V2" || "http://localhost:3050/v2";

if (process.env.VUE_APP_API_HOST) apiHost = process.env.VUE_APP_API_HOST;
if (process.env.VUE_APP_API_HOST_V2) apiV2Host = process.env.VUE_APP_API_HOST_V2;

//for production
let hostServer = apiHost;
let restServer = hostServer;



if (process.env.NODE_ENV !== "production") {
  restServer = "http://localhost:3030";
}

const socket = io(hostServer, {
  transports: ["websocket"],
  upgrade: false,
  reconnectionDelay: 1000,
});

const feathersClient = feathers();
feathersClient.configure(
  socketio(socket, {
    timeout: 90000,
  })
);
feathersClient.configure(
  auth({
    storage: window.localStorage,
  })
);

export default feathersClient;

// Setting up feathers-vuex
const {
  makeServicePlugin,
  makeAuthPlugin,
  BaseModel,
  makeBaseModel,
  models,
  FeathersVuex,
} = feathersVuex(feathersClient, {
  serverAlias: "api", // optional for working with multiple APIs (this is the default value)
  idField: "_id", // Must match the id field in your database table/collection
  whitelist: ["$regex", "$options"],
});

export {
  makeAuthPlugin,
  makeServicePlugin,
  makeBaseModel,
  BaseModel,
  models,
  FeathersVuex,
  hostServer,
  restServer,
  apiV2Host,
};
